<template>

 <section id="cotizacion">
  <div class="row">
    <div class="col-sm-12 cotitrack-fondo extranet-fondo">
      <div class="row" v-if="multimedia[0] != undefined">
        <div class="col-sm-6">
          <div class="cotitrack-contenido extranet-contenido">
            <div class="cotitrack-titulo"><h1>{{ multimedia[0].title_multimedia }}</h1></div>
            <span v-html="multimedia[0].desc_multimedia"></span>
            <div class="cotitrack-texto">
              <a id="confirm2" :href="multimedia[0].link_button_multimedia" target="_blank" class="btn btn-primary btn-video-armaq">
              <strong>{{ multimedia[0].desc_button_multimedia }}</strong>
              </a>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="cotitrack-contenido extranet-contenido">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" :src="multimedia[0].link_multimedia"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

</template>

<script>
import axios from "axios";
import { config_settings } from '../../config.js';
export default {
  name: "TwoModules",
  data() {
    return {
      multimedia: []
    };
  },
  methods: {
    getMultimedia() {
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/multimedia')
           .then(response => {
             this.multimedia = response.data
             console.log(this.multimedia)
          })
          .catch(error => {
      })
    }
  },
  //manadatory function called from cardTemplate  
  created() {
    this.getMultimedia()
  }
}
</script>

<style>
.best-products {
  margin-bottom: 10px;
}

#cotizacion {
  padding: 0px;
}
</style>